import React, { useState } from 'react';
import { useQuery } from '@apollo/client';
import { Table, Card, Button, Space, Input } from 'antd';
import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { getCategories } from '../../graphql/queries';
import { useNavigate } from 'react-router-dom';
import './Categories.css';

const Categories = () => {
  const navigate = useNavigate();
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });
  const [searchTerm, setSearchTerm] = useState('');

  const { loading, data } = useQuery(getCategories, {
    variables: {
      page: pagination.current,
      pageSize: pagination.pageSize,
    },
  });

  const handleRowClick = (record) => {
    navigate(`/categories/${record.id}`);
  };

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: '100px',
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      width: '300px',
    },
    {
      title: 'Row Number',
      dataIndex: 'rowNumber',
      key: 'rowNumber',
      width: '120px',
      sorter: (a, b) => a.rowNumber - b.rowNumber,
    },
  ];

  const handleTableChange = (paginationConfig) => {
    setPagination({
      current: paginationConfig.current,
      pageSize: paginationConfig.pageSize,
    });
  };

  // Filter data based on search term
  const filteredData = (data?.getCategories || []).filter(category =>
    category.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="categories-container">
      <Card>
        <div className="page-header">
          <div className="header-content">
            <h1>Categories</h1>
            <p>Manage and organize video categories</p>
          </div>
          <Button 
            type="primary" 
            size="large"
            icon={<PlusOutlined />}
            onClick={() => navigate('/categories/create')}
          >
            Create Category
          </Button>
        </div>

        <div className="filters-section">
          <Space size="large" wrap>
            <div className="filter-item">
              <Input
                placeholder="Search categories by name..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{ width: 250 }}
                prefix={<SearchOutlined />}
                allowClear
              />
            </div>
          </Space>
        </div>
        
        <Table
          columns={columns}
          dataSource={filteredData}
          loading={loading}
          rowKey="id"
          pagination={{
            ...pagination,
            showSizeChanger: true,
            showTotal: (total, range) => 
              `${range[0]}-${range[1]} of ${total} categories`,
          }}
          onChange={handleTableChange}
          onRow={(record) => ({
            onClick: () => handleRowClick(record),
            style: { cursor: 'pointer' }
          })}
        />
      </Card>
    </div>
  );
};

export default Categories; 